import { getSystemList } from "@iewcasia/Services/OrderService";
import setFieldValue from "@iewcasia/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Select from "@insite/mobius/Select";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (customState: CustomState) => ({
    industry: customState.customCreateAccountForm.fieldValues.industry,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const IndustryListWidget: React.FC<Props> = ({ industry, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Industry");
    const isRequired = true;
    const hintText = "Select";
    const [options, setOptions] = React.useState([]);
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, industry, "industry", () =>
        validateFieldBy(isRequired, label, industry, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        widgetSetFieldValue({ key: "industry", value: event.target.value });
    };

    const getStateOptions = async () => {
        const listValues = await getSystemList({ namelist: "IndustryList" }) as any;
        setOptions(listValues?.SystemList?.map?.((x: any) => ({ label: x.Description, value: x.Name })) || []);
    }

    React.useEffect(() => {
        getStateOptions();
    }, []);

    return (
        <Select
            label={label}
            required={isRequired}
            value={industry || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            placeholder={hintText || ""}
        >
             <option value="" {...(isRequired && { disabled: true })}>
                {translate(hintText)}
            </option>
            {options.map((country: any) => (
                <option key={country.value} value={country.name}>
                    {country.label}
                </option>
            ))}
        </Select>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(IndustryListWidget);
